/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./config.js');
require('./bootstrap.js');

require('./design/designKit.js');
require('./design/observations.js');
require('./design/addObservation.js');

require('./src/about.js');
require('./src/utils.js');
require('./src/guide.js');
require('./src/header.js');
require('./src/sidebar.js');
require('./src/dropdown.js');
require('./src/accordion.js');

require('./src/common/peopleList.js');
require('./src/common/filterPersistence');
require('./src/common/clearLocalStorage');

require('./src/schoolSelect.js');
require('./src/observations.js');
require('./src/addObservation.js');
require('./src/editObservation.js');

require('./src/observer/peopleList.js');
require('./src/observer/personProfile.js');

require('./src/districtAdmin/toolByMonth.js');
require('./src/districtAdmin/schoolByTool.js');
require('./src/districtAdmin/schoolByMonth.js');
require('./src/districtAdmin/personProfile.js');
require('./src/districtAdmin/observerByMonth.js');

require('./src/schoolAdmin/grades.js');
require('./src/schoolAdmin/departments');
require('./src/schoolAdmin/toolByMonth.js');
require('./src/schoolAdmin/personProfile.js');
require('./src/schoolAdmin/teacherByMonth.js');
require('./src/schoolAdmin/tabulationMenu.js');
require('./src/schoolAdmin/teacherOverTime.js');
require('./src/schoolAdmin/teacherOverTime.js');
require('./src/schoolAdmin/performanceByTool.js');
require('./src/schoolAdmin/teacherGoalTabProgress.js');
require('./src/schoolAdmin/utahSummativeStatusReview.js');

require('./src/gt/alerts.js');
require('./src/gt/searchBar.js');
require('./src/gt/myProgress.js');
require('./src/gt/newStandard.js');
require('./src/gt/inviteMentor.js');
require('./src/gt/messageThread.js');
require('./src/gt/composeMessage.js');
